export default "__VITE_ASSET__8b262009__"